(function () {
  function initTabs(root) {
    if (!root || root.dataset.tabsInitialized === 'true') return;
    root.dataset.tabsInitialized = 'true';

    var tablist = root.querySelector('[data-tabs-tablist]');
    var panelsContainer = root.querySelector('[data-tabs-panels]');
    if (!tablist || !panelsContainer) return;

    var tabs = panelsContainer.querySelectorAll('[data-ftc-tab]');
    if (!tabs.length) return;

    // Mueve cada botón a la fila de pestañas, dejando su panel donde estaba
    tabs.forEach(function (tab) {
      var button = tab.querySelector('[data-tab-button]');
      if (button) tablist.appendChild(button);
    });

    var buttons = tablist.querySelectorAll('[data-tab-button]');
    var panels = panelsContainer.querySelectorAll('[data-tab-panel]');

    function activate(index) {
      buttons.forEach(function (btn, i) {
        btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      panels.forEach(function (panel, i) {
        if (i === index) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        activate(index);
        btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    activate(0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-collection-tabs]').forEach(initTabs);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initAll(document);
  });

  // El personalizador de Shopify sustituye el HTML de la sección por AJAX
  // al detectar cambios — este evento nos avisa para re-inicializar.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();